<template>

    <div class="container">
      <h1>Min bar</h1>
      <Slider
        :beers="beers"
        :user="user">
      </Slider>

      <div v-if="!user.isSignedIn">
        <h3>Log ind for at se dine øl her</h3>
      </div>

      <div v-else>
        <h3 class="subtitle">Seneste øl</h3>
        <div v-if="user.drinkedBeers.length == 0">
          <p>Du har ikke drukket nogen øl endnu. Køb en øl i studenterbaren og se den dukke op her.</p>
          <i class="material-icons">local_drink</i>
        </div>
        <div v-else>
          <router-link :to="{ name: 'øl', params: { beer: latestBeer }}">
            <Feature
              :beer="latestBeer"
            ></Feature>
          </router-link>
        </div>

        <h3 class="subtitle">Bedste øl</h3>
        <div v-if="user.drinkedBeers.length == 0">
          <p>Du har ikke vurderet nogen øl endnu. De øl du bedst kunne lide vises her.</p>
          <i class="material-icons">local_drink</i>
        </div>

        <div v-for="bestBeer in bestBeers" :key="bestBeer.id">
          <router-link :to="{ name: 'øl', params: { beer: bestBeer }}">
            <Feature
              :beer="bestBeer"
            ></Feature>
          </router-link>
        </div>

      </div>

    </div>

</template>

<script>

import Feature from '../components/Feature.vue';
import Slider from '../components/Slider.vue';


export default {
  name: 'Home',
  components: {
    Feature,
    Slider
  },
  data() {
    return {
      sliderval: 10
    }
  },
  props: {
    beers: Array,
    user: Object
  },
  computed: {
    latestBeer: function(){
      let beersByDate = Array.from(this.user.drinkedBeers);
      beersByDate.sort((a, b) => {
        return new Date(b.date) - new Date(a.date);
      });
      return new Object(beersByDate[0]);
    },
    bestBeers: function(){
      // sort by highest rating, then by latest date and set max
      let maxlength = 3;
      let beersByRating = Array.from(this.user.drinkedBeers);

      beersByRating.sort((a, b) => {
        if(b.rating != a.rating){
          return b.rating - a.rating;
        }else{
          return new Date(b.date) - new Date(a.date);
        }
      });
      if(beersByRating.length > maxlength)
        beersByRating.length = maxlength;

      return beersByRating
    }
  }

}
</script>

<style scoped>

.subtitle{
  text-align: left;
  display: block;
  border-bottom: 1px solid var(--primaryColor);
  margin-top: 40px;
}
a {
  text-decoration: inherit;
  color: inherit;
}

</style>
